import { createContext } from 'react';

import type { GetRoleAccessQuery } from '@/generated/graphql';

export const PermissionsContext = createContext<
  GetRoleAccessQuery['role_access'] | null
>(null);
